import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../pipes';
import { ExceptionsComponent } from './exceptions.component';

@NgModule({
  imports: [CommonModule, PipesModule],
  declarations: [ExceptionsComponent],
  exports: [ExceptionsComponent]
})
export class ExceptionsModule {}
